import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { showErrorMessage } from '../notifications';
import { AccessTypes } from '../../components/common/domain/accountAccessType';

export interface ISignUpCredentials {
  firstName: string;
  lastName: string;
  password: string;
  tokenId: string;
  reCaptchaToken: string;
  useFallback: boolean;
}

export interface ISignUpCredentialsResponse {
  accessType?: AccessTypes;
}

export const updateProspectCredentials: AsyncThunk<ISignUpCredentialsResponse, ISignUpCredentials, ThunkAPI> = createAsyncThunk(
  'auth/signUp/proUserNameAndPassword',
  async (data: ISignUpCredentials, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<ISignUpCredentialsResponse, ISignUpCredentials>({
        endpoint: 'signUp/pro-user',
        microservice: SERVICES.AUTH_SERVICE,
        authenticated: false,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);

      if ('accessType' in response && AccessTypes.Lite.toString() === response.accessType) {
        thunk.dispatch(push('/signUp/account-creation'));
        return response;
      }
      thunk.dispatch(push('/signup/pro/subscription'));
      return response;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      if (err.statusCode !== 422) { // Recaptcha v3 gives an 422 http error
        thunk.dispatch(showErrorMessage('Your request failed. Your invitation link may have expired, please try again'));
      }
      return thunk.rejectWithValue(err);
    }
  }
);
